import React from 'react';
import { useEffect } from 'react';
import { SingletonSharedData } from '../../../../js/singletonSharedData';
import { API_ENDPOINTS, USER_STATE } from '../../../../constants';
import { actionPreviewRecord, messageApiRequest } from '../../../../redux/actions/A_messages_to_SM';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { Singleton } from '../../../../js/Singleton';
import { getCurrentTimeInSec } from '../../../../js/helpers/Utils/formats';
import {  setPreviewSelectedCampaign } from '../../../../redux/actions/A_preview';
import { AgentButton, SearchSelectionAgent, useToasts } from 'global-components-library';
import { useRef } from 'react';

const language = new Singleton();

const ChangeTypeCampaign = () => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const { initialTimeSec, totalPreviewTime, callOutId, selectedPreviewCampaign , defaultDialingRate} = useSelector(state => state.preview);
	const isFirstRender = useRef(true);
	const sharedData = new SingletonSharedData();
	const defaultCampaign =  {label:language.getText('GUIPreviewautomaticCamp'), text:language.getText('GUIPreviewautomaticCamp') , value:0, id:0, ID:0 }

	useEffect(() => {
		setTimeout(() => {
			dispatch(messageApiRequest(API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));
		}, 1000);
	}, []);
	

	const campaigns = useMemo(() => {
		
		if (sharedData.callOutCampaigns) {
			const arrayObjs =  Object.values(sharedData.callOutCampaigns)
			if(arrayObjs.length <= 0) return [];

			const defaultCampaignTemporal = {...defaultCampaign, CountJobs: arrayObjs.reduce((acm, current )=>acm + current.CountJobs, 0  )};
			const actualCampaign = selectedPreviewCampaign ? 
				[defaultCampaignTemporal, ...arrayObjs].find(item => item.ID === selectedPreviewCampaign.value) :
				defaultCampaignTemporal;			
			if(actualCampaign['CountJobs'] <= 0 && !isFirstRender.current && !!selectedPreviewCampaign){
				addToast(language.getText("GUIAlertMessagependingChange"), {
					group: 'icon', 
					position: 'topRight',
					icon: 'warning', 
					color: 'yellow', 
					btnComponent:  <AgentButton type='tertiary'>{language.getText("GUIAlertMessageclose")}</AgentButton>,
					timeout: 5000, 
				});
			}
			return [defaultCampaign,...arrayObjs.map(item => ({...item, value: item.ID, label: item.Description, text: item.Description, id: item.ID }))];
			
		}
		return [defaultCampaign];
	}, [sharedData.callOutCampaigns]);
	
	const selectCampaign = async item => {
		if(isFirstRender.current){
			isFirstRender.current = false;
			return;
		}
		if(item.value === 0 && !(!!selectedPreviewCampaign) ) return;
		
		if(!!selectedPreviewCampaign){
			if(item.value === selectedPreviewCampaign.value) return;
		}
		//TODO: aquí va la definición del factor de marcación
		dispatch(setPreviewSelectedCampaign({value:item.value, label:item.label, text:item.text}));
		setTimeout(() => {
			let time = getCurrentTimeInSec();
			let previewTime = time - initialTimeSec + totalPreviewTime;

			dispatch(actionPreviewRecord(
				{
					process:10, 
					camId:item.value, 
					callOutId:callOutId != "" ? callOutId : 0, 
					previewTime:previewTime, 
					callId:0,
					userid:sharedData.getUserData().User_id, 
					callOutType:1
				}
			))
		}, 500);
		dispatch(messageApiRequest(API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true));

		addToast(language.getText("GUIAlertMessagenoRecords"), {
			group: 'icon', 
			position: 'topRight',
			icon: '', 
			color: 'blue', 
			btnComponent: <AgentButton type='tertiary'>{language.getText("GUIAlertMessageclose")}</AgentButton>,
			timeout: 5000, 
		});
	

	};
	
	const getIndexSelectedCampaign = () => {
		if (selectedPreviewCampaign) {
			return campaigns.findIndex(item => item.value === selectedPreviewCampaign.value);
		}
		return 0;
	};

	return (
		<div className='changeTypeCampaign'>
			<SearchSelectionAgent 
				ignoreCase
				defaultIndex={getIndexSelectedCampaign()}
				options={campaigns.length > 0 ? campaigns : [defaultCampaign]}  
				filterBy={'label'} 
				onSelected={selectCampaign}/>
		</div>
	);
};
export default ChangeTypeCampaign;




// WEBPACK FOOTER //
// ./src/components/workSpace/CallComponents/ChangeTypeCampaign/ChangeTypeCampaign.jsx